import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=1eab2c5b&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eab2c5b')) {
      api.createRecord('1eab2c5b', component.options)
    } else {
      api.reload('1eab2c5b', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=1eab2c5b&", function () {
      api.rerender('1eab2c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21iSCZ0pmKba4/JS/comp/ImgFallback2.vue"
export default component.exports